import { z } from 'zod';

import { type LoggedUser } from '@/features/user/types/user-types';

export const PaywallValueSchema = z.enum([
  'paywall_from_direct_access',
  'paywall_from_menu_upgrade_button',
  'paywall_from_menu_messages_button',
  'paywall_from_header_messages_button',
  'paywall_from_user_profile_upgrade_button',
  'paywall_from_email_link',
]);

export type PaywallValue = z.infer<typeof PaywallValueSchema>;

export interface PaywallReport {
  userId: LoggedUser['id'],
  action: 'subscription_paywall_view',
  viewedFrom: PaywallValue,
}

export type ClickhouseReport = PaywallReport;

export type MessageSentSource = 'all-listings-list' | 'userprofile' | 'listingprofile' | 'search-grid' | 'mailbox';

export type MegaphoneSentSource = 'newlisting_megaphone' | 'megaphone';

export interface ElasticMegaphoneSentReport {
  action_name: 'MegaphoneSent',
  details: {
    src: MegaphoneSentSource,
    [key: string]: string | number,
  },
}

export interface ElasticPaywallVisitReport {
  action_name: 'subscription_paywall_view',
  details: {
    src: PaywallValue,
    [key: string]: string | number,
  },
}

export type ElasticReport = ElasticMegaphoneSentReport | ElasticPaywallVisitReport;
